export default function toUpperFirstCase(text){
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
}